export const NAME = "storeVisits";

export module StoreVisits {
  export interface TopStoreData {
    name: string;
    address: string;
    scaled_visits: number;
  }
}



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/constants.ts